<form class="form-pay" id="paymentDetails">
  <h3 class="form-pay__title">{{title}}</h3>
  <p class="form-pay__desc">Enter your card information to confirm your booking.</p>
  <div class="form-pay__container mb-3">
    <label class="form-pay__label">Payment Type</label>
    <div id="creditCardsList" class="select">
      <select class="form-pay__input" [(ngModel)]="selectedCardType" [ngModelOptions]="{standalone: true}">
        <option *ngFor="let card of cardTypes" [ngValue]="card">{{card}}</option>
      </select>
    </div>
  </div>
  <div class="grid-2col gap-1 mb-3">
    <div class="form-pay__container">
      <label class="form-pay__label">First Name (as on card)</label>
      <input class="form-pay__input" type="text" [(ngModel)]="firstName" name="firstName" placeholder="e.g JOHN">
    </div>
    <div class="form-pay__container">
      <label class="form-pay__label">Last Name (as on card)</label>
      <input class="form-pay__input" type="text" [(ngModel)]="lastName" name="lastName" placeholder="e.g DOE">
    </div>
  </div>
  <div class="form-pay__container mb-3">
    <label class="form-pay__label">Card Number</label>
    <input (keypress)="keyPressNumbers($event)" class="form-pay__input no-spinner" type="number" maxlength="16" [(ngModel)]="cardNumber" name="cardNumber">
  </div>
  <div class="expiration flex gap-1">
    <div class="">
      <label class="form-pay__label">Expiry Date</label>
      <div class="flex gap-1">
        <div id="expiryMonth" class="select">
          <select class="form-pay__input" [(ngModel)]="selectedMonth" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let month of months" [ngValue]="month">{{month}}</option>
          </select>
        </div>
        <div id="ccExpiryDateList" class="select">
          <select id="year-select" class="form-pay__input" [(ngModel)]="selectedYear" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let year of years" [ngValue]="year">{{year}}</option>
          </select>
        </div>
      </div>
    </div>
    <div class="flex-col jc-end">
      <label class="form-pay__label">CCV/CVC</label>
      <input class="form-pay__input form-pay__cvc" type="text" [(ngModel)]="scc" maxlength="3" max="999" name="scc">
    </div>
  </div>
</form>
<div *ngIf="isButtonsVisible()" class="update-payment">
  <button (click)="saveDeatails()" class="update-payment__button-update">Update Details</button>
  <button (click)="hideCard()" class="update-payment__button-cancel">Close</button>
</div>